export class ListRestoreJobTypesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreJobTypes",
            "baseName": "restoreJobTypes",
            "type": "Array<RestoreJobType>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreJobTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
